import * as React from 'react';

import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { WatchRenderContainer } from '../WatchScrollingContainer';

/**
 * Хук подготавливает wrapper для view-компонентов блоков на странице
 * blockRef - React ref объект, создаваемый здесь. Его нужно устанавливать на html-контейнер блока страницы
 * */
export const useScrollingRef = (blockId: EScrollingBlocks) => {
  const blockRef = React.useRef<HTMLDivElement>(null);

  return React.useCallback(
    (children: React.ReactElement) => (
      <WatchRenderContainer blockId={blockId} scrollingBlockRef={blockRef}>
        {children}
      </WatchRenderContainer>
    ),
    [blockId],
  );
};
